import React from "react";
import WhistleBlowingExplanation from "./WhistleBlowingExplanation";
import WhistleBlowingForm from "./WhistleBlowingForm";
function WhistleBlowing() {
    return (
        <>
            <div>
                <div className="hero-backgrounds">
                    <div className={`hero-background-whistle-blowing`}/>
                </div>

                <article className="hero ebp">
                    <div className="hero-message-wrapper ebp">
                        <h1> Danai.id Whistleblowing System</h1>
                        <br/><br/>
                        <p>
                            <em><b>Whistleblowing System</b></em> di Danai.id merupakan sarana pelaporan atas dugaan
                            pelanggaran yang disediakan untuk mendukung penerapan prinsip transparansi, integritas, dan
                            akuntabilitas, serta memberikan perlindungan kepada pelapor di lingkungan perusahaan.<br/>
                            Melalui penerapan <em>Whistleblowing System</em>, Danai.id menegaskan komitmennya terhadap
                            penerapan tata kelola perusahaan yang baik <em>(Good Corporate Governance)</em> serta upaya
                            menciptakan lingkungan kerja yang aman, etis, dan terpercaya.
                        </p>
                    </div>
                </article>
            </div>
            <WhistleBlowingExplanation/>
            <WhistleBlowingForm/>
        </>
    );
}

export default WhistleBlowing;